import { render, staticRenderFns } from "./TransferHistoryTable.vue?vue&type=template&id=1562e594&scoped=true&"
import script from "./TransferHistoryTable.js?vue&type=script&lang=js&"
export * from "./TransferHistoryTable.js?vue&type=script&lang=js&"
import style0 from "./TransferHistoryTable.vue?vue&type=style&index=0&id=1562e594&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562e594",
  null
  
)

export default component.exports